import { EventEmitter, Injectable, Output } from '@angular/core';
import { NavigationParameters } from '../models/navigationParameters';
import { User } from '../models/user';
import { Parameters } from '../models/parameters';
import { Staff } from '../models/staff';
import { ApplicantService } from './applicant.service';
import { Applicant } from '../models/applicant';
import { StaffDashboardService } from './staff-dashboard.service';
import { MessageService } from './message.service';

@Injectable()
export class StaffPortalService {
  @Output() getLoggedInStaff: EventEmitter<Staff> = new EventEmitter();
  @Output() getselectedLanguage: EventEmitter<string> = new EventEmitter();
  navigationParams:NavigationParameters = new NavigationParameters();
  applicant:Applicant = new Applicant();
  staff:Staff = new Staff();

  constructor(
    private applicantService:ApplicantService,
    private staffDashboardService:StaffDashboardService,
    private msg:MessageService
  ) { }


  setupCurrentUser(user:User)
  {
      if (user.token) localStorage.setItem('jwtoken', JSON.stringify(user.token));

      this.navigationParams = JSON.parse(localStorage.getItem('navigationParams'));
      if (!this.navigationParams) this.navigationParams = new NavigationParameters();

      this.navigationParams.userRole = user.role;
      this.navigationParams.hcvTCode = user.hcvTcode;
      this.navigationParams.cnvTCode = user.cnvTcode;
      this.navigationParams.affPCode = user.affPcode;
      this.navigationParams.loggedIn = true;
      this.navigationParams.loginEmail = user.email;
      localStorage.setItem('navigationParams', JSON.stringify(this.navigationParams));
      let params:Parameters = new Parameters();
      params.email = user.email;
      this.staffDashboardService.getStaffInfoHCV(params)
        .subscribe(data  => { 
          this.staff = data;
          localStorage.setItem('staff', JSON.stringify(this.staff));
          this.getLoggedInStaff.emit(this.staff);
        });
  }


  setupSelectedApplicant(params:Parameters)
  {

      this.navigationParams = JSON.parse(localStorage.getItem('navigationParams'));
      if (!this.navigationParams) this.navigationParams = new NavigationParameters();

          if (params.applicantCode.substring(0,2) == 't5')
          {
              this.applicantService.getGeneralInfoCNV(params)
              .subscribe(data  => { 
                  this.applicant.generalInfo = data;
                  this.navigationParams.tenantStatusCNV = data ? data.tenantStatus: "";
                  params.hmy = data.hmy;
                  this.applicantService.getFamilyMembersCNV(params)
                  .subscribe (f => {
                      this.applicant.familyMembers = f;
                      this.applicantService.getIncomeRentCNV(params)
                      .subscribe (i => {
                          this.applicant.incomeRent = i;
                          localStorage.setItem('applicant', JSON.stringify(this.applicant));
                          localStorage.setItem('navigationParams', JSON.stringify(this.navigationParams));
                      });
                  });
              }, (error) => {
                  this.msg.showError(error, "Login Error");
              });
          }
          else
          {
              if (params.applicantCode.substring(0,2) == 't0')
              {
                  this.applicantService.getGeneralInfoHCV(params)
                  .subscribe(data  => { 
                      this.applicant.generalInfo = data;
                      this.navigationParams.tenantStatusHCV = data ? data.tenantStatus: "";
                      //for testing only. delete the line below for GO LIVE
                      //this.applicant.generalInfo.tenantStatus = 'Applicant';
                      params.hmy = data.hmy;
                      this.applicantService.getFamilyMembersHCV(params)
                      .subscribe (f => {
                          this.applicant.familyMembers = f;
                          this.applicantService.getIncomeRentHCV(params)
                          .subscribe (i => {
                              this.applicant.incomeRent = i;
                              localStorage.setItem('applicant', JSON.stringify(this.applicant));
                              localStorage.setItem('navigationParams', JSON.stringify(this.navigationParams));
                          });
                      });
                  }, (error) => {
                      this.msg.showError(error, "Login Error");
                  });   
              }
      }
  }

}
